const NAME_KEY = 'practice_player_name_v1';
const FINGERPRINT_KEY = 'practice_player_fingerprint_v1';

export function sanitizePlayerName(name) {
  return String(name).replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 24);
}

export function getPlayerName() {
  return sanitizePlayerName(localStorage.getItem(NAME_KEY) || localStorage.getItem('qdm_player_name_v1')
    || localStorage.getItem('qdm_daily_player_name_v1') || localStorage.getItem('qdm_time_player_name_v1') || '');
}

export function savePlayerName(name) {
  const value = sanitizePlayerName(name);
  localStorage.setItem(NAME_KEY, value);
  // Keep older QDM tabs in sync during the transition.
  localStorage.setItem('qdm_player_name_v1', value);
  return value;
}

export function getPlayerFingerprint() {
  let value = localStorage.getItem(FINGERPRINT_KEY) || localStorage.getItem('qdm_player_fingerprint_v1');
  if (!value) value = crypto.randomUUID();
  localStorage.setItem(FINGERPRINT_KEY, value);
  return value;
}

export function zagrebDate(date = new Date()) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Zagreb', year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
  return `${values.year}-${values.month}-${values.day}`;
}

export function seededRandom(seed) {
  let state = 2166136261;
  for (const char of seed) state = Math.imul(state ^ char.charCodeAt(0), 16777619);
  return () => {
    state = (state + 0x6D2B79F5) | 0;
    let value = Math.imul(state ^ (state >>> 15), 1 | state);
    value ^= value + Math.imul(value ^ (value >>> 7), 61 | value);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}
